'use strict';

window.productWishList = require('./product/wishlist');
window.productWishListHeart = require('./product/wishlistHeart');
